// frontend/styleguide/index.js

import './index.scss';

import 'ez-styles/assets/javascripts/ez-styles/utils/errors';

import 'ez-styles/assets/javascripts/ez-styles/forms/general';
import 'ez-styles/assets/javascripts/ez-styles/forms/password_field';

import './icons/pro-star.svg';
import './tmp-icons/arrow-rounded-left.svg';
